<!--suppress ALL -->

<template>
  <el-dialog top="10px" title="文本生成" :visible.sync="isVisible" width="90%" :close-on-click-modal="false"
             :close-on-press-escape="false" :fullscreen="false" :append-to-body="true">


    <div ref="outputDiv"
         style="height: 400px; width: 95%; background: #fafafa; padding: 20px; overflow: auto; border-radius: 5px;font-size: 18px; margin-top: 0px">
      <vue-markdown v-for="(item,index) in output" :key="index" :source="item"></vue-markdown>
    </div>

    <el-row :gutter="20" style="margin-top: 20px">

      <el-col :span="4" :xs="24" :md="4">
        <el-select v-model="agentItemId" placeholder="选择数字员工">
          <el-option-group
              v-for="(group,index) in items"
              :key="index"
              :label="group.title">
            <el-option
                v-for="item in group.agents"
                :key="item.itemId"
                :label="item.title"
                :value="item.itemId">
            </el-option>
          </el-option-group>
        </el-select>
      </el-col>
      <el-col :span="12" :xs="24" :md="12">
        <el-input style="width:100%; " v-model="inputData" clearable @keyup.enter.native="getAiData"
                  placeholder="请输入提示词">
          <!--          <template slot="append"> </template>-->
        </el-input>
      </el-col>

      <el-col :span="6" :xs="24" :md="6">
        <el-button @click="getAiData" class="btn" style="">开始生成</el-button>
        <el-button @click="confirm" style="margin-left: 20px">确定使用</el-button>
      </el-col>

    </el-row>


  </el-dialog>
</template>


<script>

import VueMarkdown from 'vue-markdown'
import Vue from 'vue';
import Recorder from 'js-audio-recorder'

export default {
  name: 'TextGenerate',
  data() {
    return {
      type: '1',
      inputData: '',
      agentItemId: '',
      inputTitle: '',
      inputModel: '',
      generatedText: '',
      generatedImage: [],
      events: [],
      eventSource: null,
      output: [],
      word: '',
      isVisible: false,
      items: [],
    }
  },
  components: {
    VueMarkdown
  },
  methods: {

    show(text) {
      this.isVisible = true
      this.output = [];
      this.inputData = text;
      //this.getAiData()
      this.getItemList()
    },

    getItemList: function () {
      let t = this;
      this.$get(
          {
            context: t,
            path: '/agent/list/',
            params: {
              size: t.pageSize,
              start: t.currentPage
            },
            success: function (data) {
              t.items = data.items;
            }
          }
      )
    },

    confirm() {
      let result = ''
      this.output.forEach((element) => {
        result += element
      });
      //console.log(result)
      this.isVisible = false
      this.$emit("refresh", result)
    },
    //===========数据调用==============//
    getAiData() {
      let token = localStorage.getItem("token");
      if (!token) {
        console.log('未登陆')
        this.$emit("checkLogin");
        return;
      }
      if (this.inputData === '') {
        return;
      }


      this.output = []
      let t = this;
      let div = t.$refs.outputDiv;

      // this.output.push("<br>");
      // this.output.push("我：" + this.inputData);
      // this.output.push("<br>");
      let count = t.output.length;
      // this.output.push("");
      // div.scrollTop = div.scrollHeight + 50;
      this.word = "";

      const isProduction = process.env.NODE_ENV === 'production'
      let url = (isProduction ? this.$chatHost : "http://localhost:55001") + "/aigc/text/create/?prompt=" + encodeURIComponent(this.inputData) + "&agent_item_id=" + this.agentItemId + "&platform=1&user_id=" + localStorage.getItem('userId') + "&token=" + localStorage.getItem('token');
      // url = "http://127.0.0.1:55500/stream";
      //console.log(url)
      const eventSource = new EventSource(url);
      //eventSource.timeout = 6000000
      eventSource.onopen = function (e) {
        console.log("连接打开 " + new Date());
      };
      eventSource.onmessage = function (e) {
        t.inputData = ''
        let data = e.data.replace(/\\x0A/g, '\n');
        data = data.replace('<data>','').replace('</data>','')
        //if(t.inputVendor == 2 || t.inputVendor == 3 || t.inputVendor == 4 || t.inputVendor == 5) {
        data = t.word + data;
        t.word = data;
        Vue.set(t.output, count, data);
//          }else{
//            Vue.set(t.output, count, "AI: "+data);
//          }
        //div.scrollTop = div.scrollHeight;
        //console.log(data)
      };
      eventSource.onerror = function (e) {
        eventSource.close(); // 关闭连接
        console.log(e)
        console.log("连接关闭");
      };

      //this.inputData = "";

    },

  }

}
</script>
<style scoped>
@import '../assets/global.css';
</style>
